import React from "react"
import UserImage from "../../../images/lauren-tapp.png"

export default ({ space }) => (
  <img
    src={space.user_image_url || UserImage}
    alt={space.contact_name || "Lauren Tapp"}
    className={"user-image"}
  />
)
